import { useLoading } from "../context/LoadingContext";

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import { FaCalendarAlt } from "react-icons/fa";
import SelectBoxFornecedor from "../components/SelectBoxFornecedor";
import { useUser } from "../context/UserContext";
import { useRestaurante } from "../context/RestauranteContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../css/RotinasFuncionario.css";
import { format } from 'date-fns';
import BackButton from "../components/BackButton";
import GenericModal from "../components/GenericModal";
import ptBR from "date-fns/locale/pt-BR";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Notas = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useUser();
  const { restauranteId, setRestauranteId } = useRestaurante();
  const [fornecedorId, setFornecedorId] = useState("");
  const { setIsLoading } = useLoading();

  useEffect(() => {
    if (id) {
      setRestauranteId(id);
    }
  }, [id, setRestauranteId]);

  const handleBack = () => {
    navigate(`/restaurantes`);
  };

  const [searchTerm, setSearchTerm] = useState("");

  const [notes, setNotes] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dataCompra, setDataCompra] = useState('');
  const [filteredNotes, setFilteredNotes] = useState([]);
  const [isDeleteConfirmModalOpen, setIsDeleteConfirmModalOpen] =
    useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [currentNote, setCurrentNote] = useState(null);
  const [formData, setFormData] = useState({
    nomeIngrediente: "",
    fornecedorId: "",
    preco: "",
    dataCompra: "",
    pesoNota: "",
    descarte: "",
  });

  const fetchNotes = async (params = {}) => {
    setIsLoading(true); console.log('Loading started in fetchNotes');
    const user = sessionStorage.getItem("user");
    const { access_token } = JSON.parse(user);
    if (restauranteId && access_token) {
      try {
        const url = new URL(`${process.env.REACT_APP_BASE_URL}/api/v1/notas`);
        url.searchParams.append("restauranteId", restauranteId);
        url.searchParams.append("pageNumber", 0);
        url.searchParams.append("pageSize", 10);

        if (params.nome) {
          url.searchParams.append("nomeIngrediente", params.nome);
        }
        if (params.dataCompra) {
          url.searchParams.append("dataCompra", params.dataCompra);
        }
        if (params.fornecedorId) {
          url.searchParams.append("fornecedorId", params.fornecedorId);
        }

        const response = await fetch(url, {
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
        });
        if (!response.ok) {
          throw new Error("Erro ao buscar notas");
        }
        const data = await response.json();
        setNotes(data);
        setFilteredNotes(data);
      } catch (error) {
        console.error("Erro ao buscar notas:", error);
        throw error;
      } finally {
        setIsLoading(false); console.log('Loading finished in fetchNotes');
      }
    }
  };

  useEffect(() => {
    if (restauranteId) {
      fetchNotes().catch((error) => {
        toast.error("Erro ao carregar as notas.");
      });
    }
  }, [restauranteId, user]);

  const handleSearch = async () => {
    const toastId = toast.loading("Buscando notas...");
    try {
      await fetchNotes({ nome: searchTerm, dataCompra, fornecedorId });
      toast.update(toastId, {
        render: "Busca concluída!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      toast.update(toastId, {
        render: "Erro ao buscar notas.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handleEditClick = (note) => {
    setCurrentNote(note);
    setFormData(note);
    setIsFormOpen(true);
  };

  const handleDeleteClick = (note) => {
    setCurrentNote(note);
    setIsDeleteConfirmModalOpen(true);
  };

  const handleCloseDeleteConfirmModal = () => {
    setIsDeleteConfirmModalOpen(false);
    setCurrentNote(null);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (currentNote) {
      await handleSaveNote(formData);
    } else {
      await handleCreateNote();
    }
  };

  const handleCreateNote = async () => {
    const toastId = toast.loading("Processando...");
    setIsLoading(true); console.log('Loading started in handleCreateNote');
    const user = sessionStorage.getItem("user");
    const { access_token } = JSON.parse(user);
    if (restauranteId && access_token) {
      try {
        const url = new URL(`${process.env.REACT_APP_BASE_URL}/api/v1/notas`);
        url.searchParams.append("restauranteId", restauranteId);
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authentication: `${access_token}`,
          },
          body: JSON.stringify({ ...formData, restauranteId }),
        });
        if (response.ok) {
          setFormData({
            nomeIngrediente: "",
            fornecedorId: "",
            preco: "",
            dataCompra: "",
            pesoNota: "",
            descarte: "",
          });
          setIsFormOpen(false);
          fetchNotes({ nome: searchTerm, dataCompra, fornecedorId });
          toast.update(toastId, {
            render: "Nota criada com sucesso!",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });
        } else {
          const errorData = await response.json();
          toast.update(toastId, {
            render: `Erro ao criar nota: ${errorData.message}`,
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        }
      } catch (error) {
        toast.update(toastId, {
          render: "Erro ao criar nota!",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      } finally {
        setIsLoading(false); console.log('Loading finished in handleCreateNote');
      }
    }
  };

  const handleSaveNote = async (updatedNote) => {
    const toastId = toast.loading("Processando...");
    setIsLoading(true); console.log('Loading started in handleSaveNote');
    const user = sessionStorage.getItem("user");
    const { access_token } = JSON.parse(user);
    if (updatedNote && access_token) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/v1/notas/${updatedNote.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authentication: `${access_token}`,
            },
            body: JSON.stringify(updatedNote),
          }
        );

        if (response.ok) {
          setIsFormOpen(false);
          setCurrentNote(null);
          fetchNotes({ nome: searchTerm, dataCompra, fornecedorId });
          toast.update(toastId, {
            render: "Nota atualizada com sucesso!",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });
        } else {
          const errorData = await response.json();
          toast.update(toastId, {
            render: `Erro ao atualizar nota: ${errorData.message}`,
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        }
      } catch (error) {
        toast.update(toastId, {
          render: "Erro ao atualizar nota!",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      } finally {
        setIsLoading(false); console.log('Loading finished in handleSaveNote');
      }
    }
  };

  const handleConfirmDelete = async () => {
    const toastId = toast.loading("Processando...");
    setIsLoading(true); console.log('Loading started in handleConfirmDelete');
    const user = sessionStorage.getItem("user");
    const { access_token } = JSON.parse(user);
    if (currentNote && access_token) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/v1/notas/${currentNote.id}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authentication: access_token,
            },
          }
        );

        if (response.ok) {
          handleCloseDeleteConfirmModal();
          fetchNotes({ nome: searchTerm, dataCompra, fornecedorId });
          toast.update(toastId, {
            render: "Nota deletada com sucesso!",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });
        } else {
          const errorData = await response.json();
          toast.update(toastId, {
            render: `Erro ao deletar nota: ${errorData.message}`,
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        }
      } catch (error) {
        toast.update(toastId, {
          render: "Erro ao deletar nota!!",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      } finally {
        setIsLoading(false); console.log('Loading finished in handleConfirmDelete');
      }
    }
  };

  const handleCancel = () => {
    setIsFormOpen(false);
    setCurrentNote(null);
    setFormData({
      nomeIngrediente: "",
      fornecedorId: "",
      preco: "",
      dataCompra: "",
      pesoNota: "",
      descarte: "",
    });
  };

  return (
    <div className="rotinas-container">
      <ToastContainer />
      <BackButton inline />
      <h2>Notas</h2>

      <div className="filtro-container">
        <div className="periodo-selecionado">
          <span>Buscar Nota: </span>
        </div>
        <div className="filtro-data-group">
          <div className="filtro-data">
            <FaSearch className="filtro-icon" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Buscar por nota"
              className="date-picker-input"
            />
          </div>
        </div>
        <div className="periodo-selecionado">
          <span>Data da Compra: </span>
        </div>
        <div className="filtro-data">
          <FaCalendarAlt className="filtro-icon" />
          <DatePicker
            selected={selectedDate}
            onChange={(date) => {
              if (date) {
                setSelectedDate(date);
                const dataComDia = new Date(date.getFullYear(), date.getMonth(), 1);
                setDataCompra(format(dataComDia, 'yyyy-MM-dd'));
              }
            }}
            locale={ptBR}
            dateFormat="MM/yyyy"
            // showMonthYearPicker
            className="date-picker-input"
            placeholderText="Selecione mês/ano"
          />
        </div>
        <div>
          <SelectBoxFornecedor
            value={fornecedorId}
            onChange={setFornecedorId}
          />
        </div>
        <div className="botoes-superiores">
          <button className="btn-adicionar" onClick={handleSearch}>
            Buscar
          </button>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        <button
          className="btn-adicionar"
          onClick={() => {
            setCurrentNote(null);
            setFormData({
              nomeIngrediente: "",
              fornecedorId: "",
              preco: "",
              dataCompra: "",
              pesoNota: "",
              descarte: "",
            });
            setIsFormOpen(!isFormOpen);
          }}
          style={{ backgroundColor: "green" }}
        >
          {isFormOpen && !currentNote ? "Fechar" : "Criar Nota"}
        </button>
      </div>

      {isFormOpen && (
        <div className="form-container">
          <h2>{currentNote ? "Editar Nota" : "Criar Nova Nota"}</h2>
          <form onSubmit={handleFormSubmit}>
            <div className="form-group">
              <label>
                Nome Ingrediente:
                <input
                  type="text"
                  value={formData.nomeIngrediente}
                  onChange={(e) =>
                    setFormData({ ...formData, nomeIngrediente: e.target.value })
                  }
                  required
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                Fornecedor:
                <SelectBoxFornecedor
                  value={formData.fornecedorId}
                  onChange={(value) =>
                    setFormData({ ...formData, fornecedorId: value })
                  }
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                Preço:
                <input
                  type="number"
                  step="0.001"
                  placeholder="1,0"
                  value={formData.preco}
                  onChange={(e) =>
                    setFormData({ ...formData, preco: parseFloat(e.target.value) })
                  }
                  required
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                Data da Compra:
                <input
                  type="date"
                  value={formData.dataCompra}
                  onChange={(e) =>
                    setFormData({ ...formData, dataCompra: e.target.value })
                  }
                  required
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                Nota/Peso:
                <input
                  type="number"
                  step="0.001"
                  placeholder="1,0"
                  value={formData.pesoNota}
                  onChange={(e) =>
                    setFormData({ ...formData, pesoNota: e.target.value })
                  }
                  required
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                Descarte:
                <input
                  type="number"
                  step="0.001"
                  placeholder="1,0"
                  value={formData.descarte}
                  onChange={(e) =>
                    setFormData({ ...formData, descarte: e.target.value })
                  }
                />
              </label>
            </div>
            <div className="form-actions">
              <button
                type="button"
                onClick={handleCancel}
                className="btn-secundario" 
              >
                Cancelar
              </button>
              <button type="submit" className="btn-primario">
                {currentNote ? "Salvar" : "Criar"}
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="lista-aproveitamentos">
        {filteredNotes?.length > 0 ? (
          filteredNotes.map((note) => (
            <div key={note.id} className="aproveitamento-card">
              <div className="card-header">
                <span>
                  {note.nomeIngrediente} - {note.nomeFornecedor}
                </span>
                <div className="edit-delete-icons">
                  <div
                    className="edit-icon"
                    onClick={() => handleEditClick(note)}
                  >
                    <FaEdit />
                  </div>
                  <div
                    className="delete-icon"
                    onClick={() => handleDeleteClick(note)}
                  >
                    <FaTrash />
                  </div>
                </div>
              </div>
              <div className="card-detalhes">
                <p>
                  <strong>Preço:</strong> R$ {note.preco.toFixed(2)}
                </p>
                <p>
                  <strong>Data da Compra:</strong> {note.dataCompra}
</p>
                <p>
                  <strong>Nota/Peso:</strong> {note.pesoNota}
                </p>
                <p>
                  <strong>Descarte:</strong> {note.descarte}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p className="sem-resultados">Nenhuma nota encontrada.</p>
        )}
      </div>

      <GenericModal
        isOpen={isDeleteConfirmModalOpen}
        onClose={handleCloseDeleteConfirmModal}
      >
        <div className="modal-content">
          <h2>Confirmar Exclusão</h2>
          <p>
            Tem certeza que deseja excluir a nota de "
            {currentNote?.nomeIngrediente}"?
          </p>
          <div className="modal-actions">
            <button
              onClick={handleCloseDeleteConfirmModal}
              className="btn-secundario"
            >
              Cancelar
            </button>
            <button
              onClick={handleConfirmDelete}
              className="btn-primario delete-button"
            >
              Excluir
            </button>
          </div>
        </div>
      </GenericModal>
    </div>
  );
};

export default Notas;